import { h, Component } from 'preact';
import { Router } from 'preact-router';
import Bill from '../routes/bill';

// import Home from 'async!../routes/home';
// import Bill from 'async!../routes/bill';

export default class App extends Component {
	/** Gets fired when the route changes.
	 *	@param {Object} event		"change" event from [preact-router](http://git.io/preact-router)
	 *	@param {string} event.url	The newly routed URL
	 */
	handleRoute = e => {
		this.currentUrl = e.url;
	};

	render() {
		return (
			<div id="app">
				{/*<Header />*/}
				<Router onChange={this.handleRoute}>
					<Bill path="/company/:companyId/bill/:billId" />
				</Router>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./components/app.js